import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFigma = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 2,
			width: 6,
			height: 6,
			rx: 2,
			fill: "#F24E1E"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8,
			y: 2,
			width: 6,
			height: 6,
			rx: 2,
			fill: "#A259FF"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 2,
			y: 8,
			width: 6,
			height: 6,
			rx: "0 0 3 3",
			fill: "#0ACF83"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 11,
			cy: 11,
			r: 3,
			fill: "#1ABCFE"
		})
	]
});
export default SvgIconFigma;
